import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=3900ebca"
import script from "../services/Storage.js?vue&type=script&lang=js&external"
export * from "../services/Storage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports